import Tabla from "./Tabla";

export default function Campanias() {
  return (
    <>
      <Tabla />
    </>
  );
}
